document.addEventListener("DOMContentLoaded",function(){var t=document.querySelectorAll(".text-accordion");t.length&&t.forEach(function(t){var n=t.querySelector(".image-with-text__text--caption"),e=[];if(n){n.classList.add("accordion-title"),n.addEventListener("click",function(){var n=t.classList.toggle("accordion-open");e.forEach(function(t){t.style.maxHeight=n?t.scrollHeight+"px":null})});for(var i=n.nextElementSibling;i;)e.push(i),i.classList.add("content"),i.style.maxHeight=null,i.style.transition="max-height 0.3s ease-out",i=i.nextElementSibling}})});

/* ── RA Quick Add: Inline variant → Add to Cart ── */
(function() {
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.ra-variant-btn');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const orig = btn.textContent;
    btn.classList.add('loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.classList.remove('loading');
      btn.classList.add('added');
      btn.textContent = '✓';

      // Update cart count & open drawer
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Update count badges
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-cart-item-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });

      // Open cart drawer
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        // Fallback: dispatch open event
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      }

      // Reset button after 2s
      setTimeout(function() {
        btn.classList.remove('added');
        btn.classList.remove('loading');
        btn.textContent = orig;
        btn.disabled = false;
      }, 2000);
    })
    .catch(function(err) {
      console.error('[RA Quick Add] Error:', err);
      btn.classList.remove('loading');
      btn.textContent = orig;
      btn.disabled = false;
    });
  }, true);
})();


/* ── Marquee: Inject navigation arrows and connect to Swiper ── */
(function() {
  function initMarqueeNav() {
    var marquees = document.querySelectorAll('.c-slider-marquee');
    marquees.forEach(function(marquee) {
      if (marquee.dataset.navInit) return;
      marquee.dataset.navInit = '1';
      
      // Find the Swiper instance (Swiper attaches to its root element)
      var swiperEl = marquee.querySelector('.swiper, .c-slider-marquee');
      var swiper = marquee.swiper || (swiperEl && swiperEl.swiper);
      
      // Also check all child elements for swiper property
      if (!swiper) {
        var children = marquee.querySelectorAll('*');
        for (var i = 0; i < children.length; i++) {
          if (children[i].swiper) { swiper = children[i].swiper; break; }
        }
      }
      
      // Stop autoplay if still running
      if (swiper && swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
      
      // Add navigation arrows if not already present
      if (!marquee.querySelector('.ra-marquee-prev')) {
        var prev = document.createElement('button');
        prev.className = 'ra-marquee-prev';
        prev.setAttribute('aria-label', 'Previous');
        prev.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        
        var next = document.createElement('button');
        next.className = 'ra-marquee-next';
        next.setAttribute('aria-label', 'Next');
        next.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        
        marquee.style.position = 'relative';
        marquee.appendChild(prev);
        marquee.appendChild(next);
        
        if (swiper) {
          prev.addEventListener('click', function() { swiper.slidePrev(); });
          next.addEventListener('click', function() { swiper.slideNext(); });
        }
      }
    });
  }
  
  // Init after DOM ready and after a delay for Swiper to initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initMarqueeNav, 800); });
  } else {
    setTimeout(initMarqueeNav, 800);
  }
})();


/* ── Remove gradient overlay from marquee handle containers ── */
(function() {
  function removeMarqueeGradients() {
    // Fix content height and button position for tight Alo-style spacing
    document.querySelectorAll('.c-slider-marquee .c-slider__content').forEach(function(el) {
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('padding', '0', 'important');
    });
    document.querySelectorAll('.c-slider-marquee .c-slider__button-container').forEach(function(el) {
      el.style.setProperty('position', 'relative', 'important');
      el.style.setProperty('bottom', 'auto', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('margin-top', '12px', 'important');
    });
    document.querySelectorAll('.c-slider-marquee .c-slider__button-container').forEach(function(el) {
      el.style.setProperty('background-image', 'none', 'important');
      el.style.setProperty('background', 'transparent', 'important');
      el.style.setProperty('background-color', 'transparent', 'important');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(removeMarqueeGradients, 100); });
  } else {
    setTimeout(removeMarqueeGradients, 100);
  }
  // Also run after a delay to catch dynamically rendered slides
  setTimeout(removeMarqueeGradients, 1000);
  setTimeout(removeMarqueeGradients, 2000);
})();


/* ── Marquee: Persistent fix to keep handle text tight below images ── */
/* Swiper resets styles; this interval keeps our fix in place */
(function() {
  var applied = false;
  var interval = setInterval(function() {
    var btns = document.querySelectorAll('.c-slider-marquee .c-slider__button-container');
    if (btns.length === 0) return;
    btns.forEach(function(el) {
      if (el.dataset.raFixed) return; // already fixed this element
      el.style.setProperty('position', 'relative', 'important');
      el.style.setProperty('bottom', 'auto', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('margin-top', '16px', 'important');
      el.style.setProperty('background-image', 'none', 'important');
      el.style.setProperty('background', 'transparent', 'important');
      el.dataset.raFixed = '1';
    });
    document.querySelectorAll('.c-slider-marquee .c-slider__content').forEach(function(el) {
      if (el.dataset.raFixed) return;
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('padding', '0', 'important');
      el.dataset.raFixed = '1';
    });
    if (applied) clearInterval(interval);
    applied = true;
  }, 100);
  // Clear after 5 seconds
  setTimeout(function() { clearInterval(interval); }, 5000);
})();


// RA Color Filter Fix: Inject product-option color checkboxes into empty taxonomy filter
(function() {
  var colorMap = {
    'Black': '#1C1C1C', 'Blue': '#2D4B8E', 'Bordeaux': '#6B2737',
    'Grey': '#9E9E9E', 'White': '#F5F5F5', 'Navy': '#1B2A4A',
    'Green': '#2D5016', 'Red': '#C41E3A', 'Pink': '#E91E8C',
    'Brown': '#795548', 'Beige': '#D7C5A0', 'Camel': '#C19A6B',
    'Khaki': '#C3B091', 'Olive': '#808000', 'Coral': '#FF7F50',
    'Rust': '#B7410E', 'Mustard': '#FFDB58', 'Teal': '#008080'
  };

  function buildColorFilter() {
    var m = window.location.pathname.match(/\/collections\/([^\/]+)\//);
    if (!m) return;
    var handle = m[1];
    var colorDetails = document.querySelector('.js-filter[id*="color-pattern"]');
    if (!colorDetails) return;
    var ul = colorDetails.querySelector('ul');
    if (!ul) return;
    fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var counts = {};
        (data.products || []).forEach(function(p) {
          var opt = (p.options || []).find(function(o) { return o.name === 'Color'; });
          if (opt) opt.values.forEach(function(v) { counts[v] = (counts[v]||0)+1; });
        });
        if (!Object.keys(counts).length) return;
        var params = new URLSearchParams(window.location.search);
        var active = params.getAll('filter.v.option.color');
        ul.innerHTML = Object.keys(counts).sort().map(function(color, i) {
          var hex = colorMap[color] || '#888';
          var id = 'ra-cf-' + i;
          var chk = active.indexOf(color) > -1 ? ' checked' : '';
          return '<li class="list-menu__item facets__item"><div class="facets__label facet-checkbox">' +
            '<input type="checkbox" id="' + id + '" name="filter.v.option.color" value="' + color + '" form="FacetFiltersForm" class="swatch-input__input"' + chk + '>' +
            '<label for="' + id + '" style="display:flex;align-items:center;gap:8px;cursor:pointer;padding:4px 0;">' +
            '<span style="width:16px;height:16px;border-radius:50%;background:' + hex + ';border:1.5px solid rgba(0,0,0,0.2);display:inline-block;flex-shrink:0;"></span>' +
            '<span class="facet-checkbox__label">' + color + '</span>' +
            '</label></div></li>';
        }).join('');
        colorDetails.open = true;
      });
  }

  function init() { setTimeout(buildColorFilter, 150); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  var _push = history.pushState;
  history.pushState = function() { _push.apply(history, arguments); setTimeout(buildColorFilter, 400); };
})();


// RA Custom Filter Fix removed — fake .ra-filter-group sidebar no longer rendered.
// Dawn native facets (Search & Discovery) now provide real filtering on collection pages.

